import { DSText } from '@engenharia/ds-react';
import styled from 'styled-components';
import colors from '../../../../styles/theme/colors';
import { sizes } from '../../../../styles/theme/devices';

const FormInput = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
  justify-items: stretch;
  align-items: stretch;

  @media (min-width: ${sizes.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;


const ContainerRadio = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 6px;

  @media (min-width: ${sizes.tablet}) {
    gap: 8px;
    margin-top: 8px;
  }
`;

const CounterRadio = styled.div`
  display: flex;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  position: relative;

  @media (min-width: ${sizes.tablet}) {
    height: 24px;
    width: 24px;
  }

  ${({ isChecked }) =>
    isChecked &&
    `
    border-color: ${colors.primary.main};
    
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      background: ${colors.primary.main};
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      z-index: 200;
      border-radius: 50%;
    }

    @media (min-width: ${sizes.tablet}) {
      &::before {
        width: 12px;
        height: 12px;
      }
    }`}
`;

const CounterLabel = styled.div`
  align-items: center;
  background-color: ${colors.gray[50]};
  border-radius: 0 0 6px 6px;
  display: flex;
  padding: 6px 12px;
  box-sizing: border-box;
  height: 100%;
  justify-content: center;
  width: 100%;
  min-height: 30px;

  p {
    color: ${colors.gray[500]};
    font-weight: 500;
    font-size: 12px;
  }

  @media (min-width: ${sizes.tablet}) {
    padding: 8px 32px;
    min-height: 37px;

    p {
      font-size: 14px;
    }
  }
`;

const Counter = styled.div`
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.default.white};
  border: 1.5px solid ${(props) => (props.isChecked ? colors.primary.main : colors.gray[100])};
  border-radius: 8px;
  color: ${(props) => (props.isChecked ? colors.default.white : colors.gray[500])};
  display: flex;
  text-align: center;
  width: 100%;
  cursor: pointer;
  gap: 8px;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  flex-direction: column;
  min-height: 90px;

  @media (min-width: ${sizes.tablet}) {
    gap: 16px;
    min-height: 117px;
  }

  ${({ isChecked }) =>
    isChecked &&
    `${CounterLabel} {
    background-color: ${colors.primary.main};
    p {
      color: ${colors.default.white};
    }
  }`}

  @keyframes fadeIn {
    from {
      opacity: 0.85;
    }

    to {
      opacity: 1;
    }
  }

  &:hover {
    animation: fadeIn 0.3s ease forwards;
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    border-color: ${colors.orange[200]};
    border-radius: 8px;
    color: ${colors.default.white};

    ${CounterLabel} {
      background-color: ${colors.orange[200]};
      p {
        color: ${colors.primary.main};
      }
    }

    ${CounterRadio} {
      border-color: ${colors.primary.main};
    }
  }

  input[type='number'] {
    -moz-appearance: textfield;
    background-color: ${colors.default.white};
    border: 0;
    color: ${colors.default.gray};
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 500;
    height: 32px;
    margin: 16px auto;

    line-height: 1;
    text-align: center;
    width: 85px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const CounterOption = styled(DSText)`
  color: ${colors.gray[700]};
  font-size: 18px;
  font-weight: 500;
  padding: 0;
  text-align: center;

  @media (min-width: ${sizes.tablet}) {
    font-size: 24px;
  }
`;

export { FormInput, ContainerRadio, Counter, CounterRadio, CounterLabel, CounterOption };